import  { useEffect, useState } from 'react';
import closeCircle from '../../../../../Assets/Icons/close_circle.svg'
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { Button } from '@mui/material';
import { PackProposal } from '../../../../../Objects/models/PackProposal';
import { CoursePack } from '../../../../../Objects/models/CoursePack';
import CoursePackRepository from '../../../../../Repositories/CoursePackRepository';
import PackCandidacyComponent from '../../../../../Components/Dashboard/Course/candidacy/Pack';
import PackProposalRepository from '../../../../../Repositories/PackProposalRepository';

const PackCandidacy = (proposal: PackProposal) => {

    const MySwal = withReactContent(Swal)
    const [course, setCourse] = useState<CoursePack>()

    useEffect(()=> {
        CoursePackRepository.fetchCoursePackById(proposal.coursePack_id).then((response) => {
           
            
            setCourse(response)
        })
    },[])
    const cancelProposal = () => {
        Swal.clickConfirm()
        PackProposalRepository.deletePackProposal(proposal.id!).then(() => window.location.reload())
    }
    const showDialogue = () => {
        let timerInterval: any
        MySwal.fire({
            showConfirmButton: false,
            html:
                <div>
                    <div className='flex items-center justify-between text-xl font-extrabold uppercase text-first'>
                        <p>RETIRER MA CANDIDATURE</p>
                        <img onClick={() => Swal.close()} className='cursor-pointer' src={closeCircle} alt="" />
                    </div>
                    <div className="py-8 text-left">
                        <div>
                            <p className='text-[20px] font-semibold text-normal'>Êtes-vous sûr de vouloir retirer votre candidature ?</p>
                        </div>
                        <div className="flex justify-between gap-8 pt-14">
                            <Button onClick={() => Swal.clickCancel()} className='w-full font-extrabold border-2 border-solid rounded-full font-extbg-transparent font-extrabolduppercase text-third border-third' >Annuler</Button>
                            <Button onClick={() => cancelProposal()} className='w-full font-extrabold border-2 border-solid rounded-full font-extbg-transparent font-extrabolduppercase text-first border-first' >Confirmer</Button>
                        </div>
                    </div>
                </div>
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Supprimée !',
                    icon: 'success',
                    text: "Votre candidature viens d'être retirée.",
                    timer: 5000,
                    showConfirmButton: false,
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                })
            }
        })
        MySwal.getPopup()?.classList.add('shadow-candidature-close')
        MySwal.getPopup()?.classList.add('w-max')
        MySwal.getPopup()?.classList.add('rounded-[20px]')
    }
    const getWeeklyHours = () => {
        if (course) {
            const duration = course.durationPerDay / 2
            const days = course.dates.length
            return  duration * days
        }
        return 0
    }
    return (
        <div className='w-max'>
            <PackCandidacyComponent {...proposal} />
            <div className='shadow-candidancy-sub p-6 pb-2 lg:pb-6 rounded-[10px] mx-auto md:mx-0 my-4'>
                <p className='flex items-center text-xl font-bold text-first'>Rémunération pour ce stage</p>
                <p className='pl-2 font-bold text-[28px] text-first'>{proposal.teachrPrice && (parseFloat(proposal.teachrPrice) * getWeeklyHours()).toFixed(2)} €</p>
                <button onClick={() => showDialogue()} className='text-[16px] underline text-normal mx-auto w-full lg:hidden'> Retirer la candidature </button>
            </div>
            <button onClick={() => showDialogue()} className='text-[16px] underline text-normal mx-auto w-full hidden lg:block'> Retirer la candidature </button>
        </div>
    );
};

export default PackCandidacy;